exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#counter[data-v-57a8e3f9] {\n    border: 1px solid #ccc;\n    border-top: 0;\n    padding: 0.5rem 1rem;\n    text-align: right;\n}\n.emoji-frame[data-v-57a8e3f9]{\n    position: absolute;\n    z-index:1;\n    margin-top: -60px;\n    margin-left: 120px;\n    background-color: #f6f6f6;\n}\n#editor[data-v-57a8e3f9] {\n    background-color: white;\n}\n.ql-formats[data-v-57a8e3f9] {\n    margin: 0 !important;\nbutton[data-v-57a8e3f9] {\n        height: unset;\n        white-space: nowrap;\n}\n}\n.obs-span[data-v-57a8e3f9] {\n  font-size: x-small;\n  margin: 3px;\n  padding: 3px;\n}\n", ""]);

// exports
